import React from 'react'
import usePlayerUserData, { defaultState, UsePlayerUserData } from '../libs/usePlayerUserData'


export const PlayerUserDataContext = React.createContext<UsePlayerUserData>(defaultState)

const { Provider } = PlayerUserDataContext

const PlayerUserDataProvider = ({ children }) => {

  const playerUserData = usePlayerUserData()

  return <Provider value={playerUserData}> {children} </Provider>

}

export default PlayerUserDataProvider
